import { LoginResponseBodyUserType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const shopifyLogin = async (_shopId: string) => {
  let shopId = _shopId;
  if (!shopId.endsWith(".myshopify.com")) {
    shopId += ".myshopify.com";
  }
  const resp = await api.post<LoginResponseBodyUserType>("/v2/auth/shop", {
    shopId,
  });
  return resp.data;
};

export const useShopifyLogin = () => {
  return useMutation({
    mutationFn: async (token: string) => shopifyLogin(token),
    onSuccess: (data) => {
      if (data && "redirect" in data) {
        // @ts-ignore
        window.location.href = data.redirect;
      } else if (data && data.user && "redirect" in data.user) {
        // @ts-ignore
        window.location.href = data.user.redirect;
      }
    },
  });
};
